import {
  TEntityResponse,
  TEntityListResponse,
  TCreateInputWebhookReqBody,
  TInputWebhookResBody,
  TInputWebhookSummaryResBody,
  TUpdateInputWebhookReqBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TInputWebhooksClient = {
  create(body: TCreateInputWebhookReqBody): Promise<TEntityResponse<'input-webhook', TInputWebhookResBody> | undefined>;
  update(
    id: string,
    body: TUpdateInputWebhookReqBody
  ): Promise<TEntityResponse<'input-webhook', TInputWebhookResBody> | undefined>;
  delete(id: string): Promise<void>;
  get(id: string): Promise<TEntityResponse<'input-webhook', TInputWebhookResBody> | undefined>;
  list(
    limit: number,
    page: number
  ): Promise<TEntityListResponse<'input-webhook', TInputWebhookSummaryResBody> | undefined>;
};

function InputWebhooksClient(apiClient: TAPIClient): TInputWebhooksClient {
  return {
    async create(
      body: TCreateInputWebhookReqBody
    ): Promise<TEntityResponse<'input-webhook', TInputWebhookResBody> | undefined> {
      const data = await apiClient.post<
        TCreateInputWebhookReqBody,
        TEntityResponse<'input-webhook', TInputWebhookResBody>
      >(`/input-webhooks`, body);

      if (data && data.type !== 'input-webhook') {
        throw new Error('Invalid entity type received, expected: input-webhook, received: ' + data.type);
      }

      return data;
    },

    async update(
      id: string,
      body: TUpdateInputWebhookReqBody
    ): Promise<TEntityResponse<'input-webhook', TInputWebhookResBody> | undefined> {
      const data = await apiClient.put<
        TUpdateInputWebhookReqBody,
        TEntityResponse<'input-webhook', TInputWebhookResBody>
      >(`/input-webhooks/${id}`, body);

      if (data && data.type !== 'input-webhook') {
        throw new Error('Invalid entity type received, expected: input-webhook, received: ' + data.type);
      }

      return data;
    },

    async delete(id: string): Promise<void> {
      return await apiClient.delete(`/input-webhooks/${id}`);
    },

    async get(id: string): Promise<TEntityResponse<'input-webhook', TInputWebhookResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'input-webhook', TInputWebhookResBody>>(`/input-webhooks/${id}`);

      if (data && data.type !== 'input-webhook') {
        throw new Error('Invalid entity type received, expected: input-webhook, received: ' + data.type);
      }

      return data;
    },

    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'input-webhook', TInputWebhookSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'input-webhook', TInputWebhookSummaryResBody>>(
        `/input-webhooks?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'input-webhook') {
        throw new Error('Invalid entity type received, expected: input-webhook, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TInputWebhooksClient, InputWebhooksClient };
